
import { broadcast, getAppUrl, setGlobalStorage, getGlobalStorage, removeGlobalStorage } from '@platform/api';
import { isFunction } from '../../libs/utils';

export class Portal {

    constructor(props) {
        // 一个唯一的Id，避免当前页面的通信，影响了其他界面
        this.pageUniqueId = this.getPageUniqueId();
        // 挂载pageScope和smartCard id
        this.smartCardSign = 'smartCard_' + this.pageUniqueId;
        // 门的标志
        this.smartCardPortalSign = 'smartCard_portal' + this.pageUniqueId;
    }

    // 生成整个页面的唯一id
    getPageUniqueId() {
        // const { pageid, pageurl } = getAppUrl();
        let parentWindow = window.parent;
        //只要保证需要通信的window是同一个id就行
        if (parentWindow.__pageUniqueId) {
            if (parentWindow.location.href.includes('approve') || parentWindow.location.href.includes('zycl')) {
                window.__pageUniqueId = parentWindow.__pageUniqueId;
            }
        }

        window.__pageUniqueId = window.__pageUniqueId || (new Date()).getTime();

        return window.__pageUniqueId;
    }

    // 使用api对象，门共用的对象
    getGlobal() {
        const globalAPI = [];
        if (!window[this.smartCardPortalSign]) {
            window[this.smartCardSign] && globalAPI.push(window[this.smartCardSign]);
        }

        // 往上找
        this.findParent(parentWindow => {
            !parentWindow[this.smartCardPortalSign] && parentWindow[this.smartCardSign] && globalAPI.push(parentWindow[this.smartCardSign]);
        });

        this.findIframe(document, win => {
            !win[this.smartCardPortalSign] && win[this.smartCardSign] && globalAPI.push(win[this.smartCardSign]);
        });

        return globalAPI;
    }

    // 安装api  一个页面只有一个smartCard
    installGlobal(pageScope, id) {
        window[this.smartCardSign] = { pageScope, id };
    }

    // 移除
    uninstallGlobal() {
        window[this.smartCardSign] = null;
    }

    // 递归父级
    findParent(callback) {
        // 往上找
        let parentWindow = window.parent;

        // 没有parent
        if (parentWindow !== window) {
            // 避免 下面的循环都没有直接执行 (第一次)
            if (callback && callback(parentWindow)) {
                return true;
            }
            
            // 第一次执行完成之后
            try {
                parentWindow = parentWindow.parent;
                parentWindow?.document;
            } catch (error) {
                console.warn('accessing a cross-origin frame');
                return false;
            }

            // 循环查找
            while (parentWindow !== top &&
                parentWindow.document.body.getAttribute('id') !== 'workbench'
            ) {
                if (callback && callback(parentWindow)) {
                    return true;
                }
                // iframe 查找跨域兼容
                try {
                    parentWindow = parentWindow.parent;
                    parentWindow?.document;
                } catch (error) {
                    console.warn('accessing a cross-origin frame');
                    return false;
                }
            }
        }
    }

    //递归子级
    findIframe(doc, callback) {
        let result = false;
        let iframe = doc?.querySelectorAll('iframe');
        if (iframe && iframe.length) {
            iframe.forEach(element => {
                let win = null;
                let doc = null;
                try {
                    win = element?.contentWindow;
                    doc = win?.document;
                    // doc.body;
                } catch (error) {
                    console.warn('accessing a cross-origin frame');
                    return false;
                }

                if (win && doc) {
                    if (callback && callback(win)) {
                        result = true;
                        return true;
                    }
                    // 递归
                    result = this.findIframe(doc, callback);
                    if (result) {
                        return result;
                    }
                }
            });
        }

        return result;
    }

    // window上添加特殊标识
    addPortalSign() {
        window[this.smartCardPortalSign] = true;
    }

    // window上移除特殊标识
    removePortalSign() {
        delete window[this.smartCardPortalSign];
    }

    // window上有特殊标识
    hasPortalSign() {
        return window[this.smartCardPortalSign];
    }

    // window上添加特殊标识
    getPortal() {

        const portal = [];

        if (window[this.smartCardPortalSign]) {
            window[this.smartCardSign] && portal.push(window[this.smartCardSign]);
        }

        // 往上找
        this.findParent(parentWindow => {
            if (parentWindow[this.smartCardPortalSign]) {
                parentWindow[this.smartCardSign] && portal.push(parentWindow[this.smartCardSign]);
            }
        });

        this.findIframe(document, win => {
            if (win[this.smartCardPortalSign]) {
                win[this.smartCardSign] && portal.push(win[this.smartCardSign]);
            }
        });

        return portal;
    }

    static getInstance() {
        return new Portal();
    }
}

export const PortalObj = Portal.getInstance();

PortalObj.Portal = Portal;

export default PortalObj;
